import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-colored-pill',
  imports: [],
  templateUrl: './colored-pill.component.html',
  styleUrl: './colored-pill.component.scss'
})
export class ColoredPillComponent {
  @Input() bgColor!: string;
  @Input() borderColor!: string;
  @Input() textColor!: string;
  @Input() text!: string;
  
  constructor() { }
}
